var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Tooltip, Typography } from 'antd';
import Icon, { DownloadOutlined, NodeIndexOutlined, PaperClipOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Trans, withTranslation } from 'react-i18next';
import FileSaver from "file-saver";
import classnames from 'classnames';
import { withStore } from '../../../store/rootStore';
import { CHAT_STATUS } from '../../../constants';
import { ReactComponent as ReplyIcon } from '../../../assets/icons/arrows/replyIcon.svg';
import blankProfilePicture from '../../../assets/avatars/blankProfilePicture.png';
import { getDownloadUrlBasedOnPlatform } from '../../../helpers';
import styles from './ReplyPreview.module.scss';
const { Text } = Typography;
class ReplyPreview extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "getReplyType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (replyType) => {
                if (replyType === CHAT_STATUS.BOT) {
                    return 'withBot';
                }
                else if (replyType === CHAT_STATUS.ASSIGNED) {
                    return 'pendingTo';
                }
                else if (replyType === CHAT_STATUS.RESOLVED) {
                    return 'resolve';
                }
            }
        });
        Object.defineProperty(this, "getAgentOrDepartment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (agent, department) => {
                var _a;
                const { users } = this.props.store.agentsStore;
                const { departments } = this.props.store.departmentsStore;
                let name = '';
                if (agent) {
                    const chosenAgent = users.find((user) => user.uid === agent);
                    if (chosenAgent) {
                        name = (chosenAgent === null || chosenAgent === void 0 ? void 0 : chosenAgent.displayName) || '';
                    }
                }
                else {
                    const chosenDepartment = departments.find((dep) => dep._id === department);
                    if (chosenDepartment) {
                        name = chosenDepartment === null || chosenDepartment === void 0 ? void 0 : chosenDepartment.name;
                    }
                }
                return name || ((_a = this.props.i18n) === null || _a === void 0 ? void 0 : _a.t('unknown'));
            }
        });
        Object.defineProperty(this, "getDepartmentColor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (departmentId) => {
                const { departments } = this.props.store.departmentsStore;
                const chosenDepartment = departments.find((dep) => dep._id === departmentId);
                let color = '#FFF';
                if (chosenDepartment) {
                    color = chosenDepartment.color;
                }
                return color;
            }
        });
        Object.defineProperty(this, "downloadFile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                if (!this.props.store.activeChatStore.chat)
                    return;
                const { replyAction } = this.props.store.activeChatStore.chat;
                if (replyAction && replyAction.replyToTemplateFile) {
                    const url = yield getDownloadUrlBasedOnPlatform((_a = replyAction.replyToTemplateFile) === null || _a === void 0 ? void 0 : _a.url);
                    if (window.ReactNativeWebView) {
                        window.open((_b = replyAction.replyToTemplateFile) === null || _b === void 0 ? void 0 : _b.url, '_blank');
                    }
                    else {
                        FileSaver.saveAs(url, (_c = replyAction.replyToTemplateFile) === null || _c === void 0 ? void 0 : _c.name);
                    }
                }
            })
        });
    }
    render() {
        const { chat } = this.props.store.activeChatStore;
        if (!(chat === null || chat === void 0 ? void 0 : chat.replyAction)) {
            return null;
        }
        const { replyText, chatStatus, replyToTemplateFile, responsibleAgent, responsibleDepartment, setBotNode } = chat.replyAction;
        const hasMessage = (chatStatus === CHAT_STATUS.RESOLVED || chatStatus === CHAT_STATUS.ASSIGNED)
            && (replyText || replyToTemplateFile);
        return (React.createElement("div", { className: styles.block },
            React.createElement("div", { className: styles.primaryRow },
                React.createElement(Icon, { className: styles.icon, component: ReplyIcon }),
                React.createElement(Text, { className: styles.label },
                    React.createElement(Trans, { i18nKey: "autoReplyTitle" })),
                React.createElement(Text, { className: styles.value },
                    React.createElement(Trans, { i18nKey: typeof chatStatus === 'number' ? this.getReplyType(chatStatus) : undefined })),
                chatStatus === CHAT_STATUS.ASSIGNED && (React.createElement(React.Fragment, null,
                    responsibleAgent && React.createElement("img", { className: styles.avatar, src: blankProfilePicture }),
                    responsibleDepartment && (React.createElement("div", { style: { backgroundColor: this.getDepartmentColor(responsibleDepartment) }, className: styles.departmentColor })),
                    React.createElement(Text, { className: styles.assignedToName, title: this.getAgentOrDepartment(responsibleAgent, responsibleDepartment) }, this.getAgentOrDepartment(responsibleAgent, responsibleDepartment)))),
                chatStatus === CHAT_STATUS.BOT && (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: styles.separator }),
                    React.createElement(NodeIndexOutlined, { className: styles.icon }),
                    React.createElement(Text, { className: styles.label },
                        React.createElement(Trans, { i18nKey: "nodeTitle" })),
                    React.createElement(Text, { className: styles.value }, setBotNode || 'start'))),
                hasMessage && replyText && (React.createElement("span", { className: classnames(styles.separator, styles.desktopOnly) })),
                hasMessage && replyText && (React.createElement(Text, { className: classnames(styles.label, styles.desktopOnly) },
                    React.createElement(Trans, { i18nKey: "messageTitle" }))),
                hasMessage && replyText && (React.createElement(Text, { title: replyText, className: classnames(styles.messageText, styles.desktopOnly) }, replyText)),
                hasMessage && replyToTemplateFile && (React.createElement("span", { className: classnames(styles.separator, styles.desktopOnly) })),
                hasMessage && replyToTemplateFile && (React.createElement("div", { className: classnames(styles.filePill, styles.desktopOnly), onClick: this.downloadFile, title: replyToTemplateFile.name },
                    React.createElement(PaperClipOutlined, { className: styles.fileIcon }),
                    React.createElement(Text, { className: styles.fileName }, replyToTemplateFile.name),
                    React.createElement(DownloadOutlined, { className: styles.fileIcon }))),
                React.createElement(Tooltip, { arrowPointAtCenter: true, placement: "bottomRight", title: React.createElement(Trans, { i18nKey: "actionWhenReplyHelp" }) },
                    React.createElement(QuestionCircleOutlined, { className: styles.helpIcon }))),
            hasMessage && replyText && (React.createElement("div", { className: classnames(styles.secondaryRow, styles.mobileOnly) },
                React.createElement(Text, { className: styles.label },
                    React.createElement(Trans, { i18nKey: "messageTitle" })),
                React.createElement(Text, { title: replyText, className: styles.messageText }, replyText))),
            hasMessage && replyToTemplateFile && (React.createElement("div", { className: classnames(styles.secondaryRow, styles.mobileOnly) },
                React.createElement("div", { className: styles.filePill, onClick: this.downloadFile, title: replyToTemplateFile.name },
                    React.createElement(PaperClipOutlined, { className: styles.fileIcon }),
                    React.createElement(Text, { className: styles.fileName }, replyToTemplateFile.name),
                    React.createElement(DownloadOutlined, { className: styles.fileIcon }))))));
    }
}
export default withTranslation()(withStore(observer(ReplyPreview)));
